import React, { ReactElement, useEffect, useState } from 'react';
import { Auth } from '@aws-amplify/auth';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import history from 'common/utils/history';
import { loginComplete } from 'redux-modules/auth/Actions';
import { getInvestorDetails } from 'redux-modules/investor/Actions';
import { getInvestorAllDeal } from 'redux-modules/deals/Actions';

type Props = {
  children: ReactElement;
};

const AuthWrapper = ({ children }: Props) => {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const pathName = useLocation().pathname;
  const search = useLocation().search;

  //Not called after login
  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        const userObj = {
          ...user.attributes,
          role: user.attributes['custom:role'],
          investorId: user.attributes['custom:investor_id'],
          referred: user.attributes['custom:referred'],
        };
        dispatch(loginComplete(userObj));
        dispatch(getInvestorDetails());
        dispatch(getInvestorAllDeal());
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        history.push({
          pathname: pathName,
          search: search,
        });
      });
  }, [dispatch]);

  return isLoading ? <div className="loader" /> : children;
};

export default AuthWrapper;
